import { usePermission } from 'auth';
import { parseJSON } from 'date-fns';
import { useTranslations } from 'i18n';
import { ActionButton, DismissButton } from 'notifications/buttons';
import { UserPermissionsEnum } from 'oas';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { round } from 'shared';
import { NotificationView } from '../notification-view';
import { NotificationTypeProps } from './notification-type-props';
import { getProfileVars } from './profile-helpers';

export const NewMaxMechanicalPower: React.FC<NotificationTypeProps> = ({ notification, handleToggleRead }) => {
    const { __ } = useTranslations();
    const canAction = usePermission(UserPermissionsEnum.SettingsBands);

    if (!notification.activities?.length || !notification.athletes?.length || !notification.period) {
        return <></>;
    }

    const { athleteName, athleteIcon, oldMax, newMax, changeDetails, periodDetails } = getProfileVars(__, notification);

    return (
        <NotificationView
            icon={athleteIcon}
            title={__('notifications.new_max_mechanical_power_title', { athleteName })}
            contents={
                <>
                    <ReactMarkdown>
                        {__('notifications.new_max_mechanical_power_prev', {
                            prevMechanicalPower: `${round(oldMax, 2)}`,
                        })}
                    </ReactMarkdown>{' '}
                    |{' '}
                    <ReactMarkdown>
                        {__('notifications.new_max_mechanical_power_new', {
                            newMechanicalPower: `${round(newMax, 2)}`,
                        })}
                    </ReactMarkdown>{' '}
                    {changeDetails}
                    <br />
                    {periodDetails}
                </>
            }
            createdAt={parseJSON(notification.created_at)}
            isRead={notification.read === 1}
            onToggleRead={handleToggleRead}
            actions={
                canAction
                    ? [
                          <DismissButton key="dismiss" notification={notification} />,
                          <ActionButton key="action" notification={notification}>
                              {__('misc.update')}
                          </ActionButton>,
                      ]
                    : []
            }
        />
    );
};
